export type CategoriaAsistencia = 'eskola' | 'f7' | 'f11'

// Issues #41 ("Meses de entrenamiento") y #42e del club, 2026-10-02: la temporada deportiva no
// coincide con el año natural y varía por modalidad — F11 empieza en agosto, F7 en septiembre y
// UKE Eskola en octubre, y las tres terminan en mayo del año siguiente. Antes (issue #33) el
// selector mostraba siempre enero-diciembre del año en curso, igual para todas las categorías.
const MES_INICIO: Record<CategoriaAsistencia, number> = {
  f11: 8, // agosto
  f7: 9, // septiembre
  eskola: 10, // octubre
}

const MES_FIN = 5 // mayo, igual para las tres modalidades

export function mesesTemporada(categoria: CategoriaAsistencia, referencia: Date = new Date()): string[] {
  const mesInicio = MES_INICIO[categoria]
  const mesActual = referencia.getUTCMonth() + 1
  const anioActual = referencia.getUTCFullYear()
  // Si el mes actual ya alcanzó el mes de inicio, la temporada en curso empezó este año natural;
  // si no (p.ej. febrero), empezó el año natural anterior.
  const anioInicio = mesActual >= mesInicio ? anioActual : anioActual - 1

  const meses: string[] = []
  let anio = anioInicio
  let mes = mesInicio
  for (;;) {
    meses.push(`${anio}-${String(mes).padStart(2, '0')}`)
    if (mes === MES_FIN) break
    mes += 1
    if (mes > 12) {
      mes = 1
      anio += 1
    }
  }
  return meses
}
